export const BIC_NL = {
  ABNA: "ABNANL2A",
  ADYB: "ADYBNL2A",
  AEGO: "AEGONL2U",
  ANDL: "ANDLNL2A",
  ARBN: "ARBNNL22",
  ARSN: "ARSNNL21",
  ASNB: "ASNBNL21",
  ATBA: "ATBANL2A",
  BCDM: "BCDMNL22",
  BCIT: "BCITNL2A",
  BICK: "BICKNL2A",
  BINK: "BINKNL21",
  BKCH: "BKCHNL2R",
  BKMG: "BKMGNL2A",
  BLGW: "BLGWNL21",
  BMEU: "BMEUNL21",
  BNDA: "BNDANL2A",
  BNGH: "BNGHNL2G",
  BNPA: "BNPANL2A",
  BOFA: "BOFANLNX",
  BOFS: "BOFSNL21002",
  BOTK: "BOTKNL2X",
  BUNQ: "BUNQNL2A",
  CHAS: "CHASNL2X",
  CITC: "CITCNL2A",
  CITI: "CITINL2X",
  COBA: "COBANL2X",
  DEUT: "DEUTNL2A",
  DHBN: "DHBNNL2R",
  DLBK: "DLBKNL2A",
  DNIB: "DNIBNL2G",
  EBUR: "EBURNL21",
  FBHL: "FBHLNL2A",
  FLOR: "FLORNL2A",
  FRGH: "FRGHNL21",
  FRNX: "FRNXNL2A",
  FTSB: "ABNANL2A",
  FVLB: "FVLBNL22",
  GILL: "GILLNL2A",
  HAND: "HANDNL2A",
  HHBA: "HHBANL22",
  HSBC: "HSBCNL2A",
  ICBK: "ICBKNL2A",
  INGB: "INGBNL2A",
  ISAE: "ISAENL2A",
  ISBK: "ISBKNL2A",
  KABA: "KABANL2A",
  KASA: "KASANL2A",
  KNAB: "KNABNL2H",
  KOEX: "KOEXNL2A",
  KRED: "KREDNL2X",
  LOCY: "LOCYNL2A",
  LOYD: "LOYDNL2A",
  LPLN: "LPLNNL2F",
  MHCB: "MHCBNL2A",
  MOYO: "MOYONL21",
  NNBA: "NNBANL2G",
  NWAB: "NWABNL2G",
  PCBC: "PCBCNL2A",
  RABO: "RABONL2U",
  RBRB: "RBRBNL21",
  SNSB: "SNSBNL2A",
  SOGE: "SOGENL2A",
  TEBU: "TEBUNL2A",
  TRIO: "TRIONL2U",
  UBSW: "UBSWNL2A",
  UGBI: "UGBINL2A",
  VOWA: "VOWANL21",
  ZWLB: "ZWLBNL21",
  REVO: "REVONL22"
}
